export const SETUP_LABEL_GENERAL_INFORMATION =
  "setup.label-general-information";
export const SETUP_LABEL_CONFIGURATION = "setup.label-configuration";
export const SETUP_LABEL_ORDER_PAGE = "setup.label-order-page";
export const SETUP_LABEL_PAYMENTS = "setup.label-payments";
export const SETUP_LABEL_CREDITS = "setup.label-credits";
